import { Icon } from "../../../components/icons";
import { MOCK_CATEGORIES, MOCK_CLUB, MOCK_ELIM_PLAYERS, MOCK_PRICES, MOCK_TOURNAMENT, formatMxn, initialsOf } from "../mockData";
import { MockFigure, PaperSheet } from "./frames";
import "./BrandComposite.css";

/**
 * M11 · Tu marca: convocatoria en PDF con el logo del club, credencial
 * digital con QR y banner del patrocinador en la app del jugador.
 * El QR es solo un marcador (3 esquinas y la palabra «QR»): no es un patrón
 * que alguien intente escanear.
 */

const PLAYER = MOCK_ELIM_PLAYERS.salazar;
const [varonil] = MOCK_CATEGORIES;
/** Convocatoria: solo los precios por tipo de jugador (general y socio). */
const FEE_LINE = MOCK_PRICES.slice(0, 2)
  .map((price) => `${price.label} ${formatMxn(price.amount)}`)
  .join(" · ");

const CALL_BLOCKS: { label: string; value: string }[] = [
  { label: "Fechas", value: MOCK_TOURNAMENT.dates },
  { label: "Sede", value: MOCK_CLUB.name },
  { label: "Costo", value: FEE_LINE },
  { label: "Categorías", value: MOCK_CATEGORIES.join(" · ") },
];

export function BrandComposite({ className = "" }: { className?: string }) {
  return (
    <MockFigure
      className={`mk-brand ${className}`.trim()}
      label="Convocatoria en PDF de la Copa Otoño 2026 con el logo del club, fechas, sede, costo y categorías; credencial digital de Diego Salazar con el logo del club, código QR y sello de válida; y el banner del patrocinador oficial en la app del jugador."
    >
      <div className="mk-brand__stage">
        <PaperSheet className="mk-brand__sheet">
          <div className="mk-brand__sheet-head">
            <div>
              <span className="mk-brand__doc-kicker">Convocatoria</span>
              <span className="mk-brand__doc-title">{MOCK_TOURNAMENT.name}</span>
              <span className="mk-brand__doc-sub">Torneo de tenis · {MOCK_CLUB.name}</span>
            </div>
            <span className="mk-brand__logo-slot">Logo de tu club</span>
          </div>

          <div className="mk-brand__sheet-body">
            <dl className="mk-brand__facts">
              {CALL_BLOCKS.map((block) => (
                <div key={block.label}>
                  <dt>{block.label}</dt>
                  <dd>{block.value}</dd>
                </div>
              ))}
            </dl>
            <div className="mk-brand__lines" aria-hidden="true">
              <i />
              <i />
              <i />
              <i />
            </div>
          </div>
        </PaperSheet>

        <div className="mk-brand__cred">
          <div className="mk-brand__cred-head">
            <span className="mk-brand__logo-slot mk-brand__logo-slot--small">Logo de tu club</span>
            <span className="mk-brand__cred-kicker">Credencial del torneo</span>
          </div>
          <div className="mk-brand__cred-person">
            <span className="mk-brand__photo">{initialsOf(PLAYER)}</span>
            <span className="mk-brand__cred-text">
              <strong>{PLAYER}</strong>
              <small>{varonil}</small>
              <small>{MOCK_TOURNAMENT.name}</small>
            </span>
          </div>
          <div className="mk-brand__cred-foot">
            <QrPlaceholder />
            <span className="mk-brand__valid">
              <CheckGlyph />
              Válida
            </span>
          </div>
        </div>

        <div className="mk-brand__strip">
          <div className="mk-brand__strip-bar">
            <Icon name="trophy" />
            <span>{MOCK_TOURNAMENT.name}</span>
            <small>{varonil}</small>
          </div>
          <div className="mk-brand__banner">
            <span className="mk-brand__banner-logo">
              <Icon name="megaphone" />
            </span>
            <span className="mk-brand__banner-text">
              <small>Patrocinador oficial</small>
              <strong>Tu marca aquí</strong>
            </span>
          </div>
        </div>
      </div>
    </MockFigure>
  );
}

/** Marcador de QR: solo las 3 esquinas de posición y la palabra «QR». */
function QrPlaceholder() {
  return (
    <span className="mk-brand__qr">
      <i className="mk-brand__qr-eye mk-brand__qr-eye--tl" />
      <i className="mk-brand__qr-eye mk-brand__qr-eye--tr" />
      <i className="mk-brand__qr-eye mk-brand__qr-eye--bl" />
      <b>QR</b>
    </span>
  );
}

function CheckGlyph() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="m5 12.5 4.5 4.5L19 7.5" />
    </svg>
  );
}
